/* eslint-disable @typescript-eslint/no-unused-vars */
import { Direction } from './constants';
import { createGettextApi } from './gettext-api';
/**
 * Utility function to omit all i18n props from an object. Useful when forwarding props
 * to a child component if you don't want to forward all of the i18n props.
 *
 * @param props object containing i18n props
 * @returns the same props object, excluding all i18n props
 */
export function omitI18nProps(props) {
  const {
    direction,
    dgettext,
    dngettext,
    dpgettext,
    gettext,
    interpolate,
    lang,
    locale,
    ngettext,
    npgettext,
    ninterpolate,
    pgettext,
    ...cleanProps
  } = props;
  return cleanProps;
}
export function createMockI18nApi() {
  let translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const api = createGettextApi(translations, 'en');
  const lang = 'en';
  const locale = 'en_US';
  return {
    ...api,
    lang,
    locale,
    direction: Direction.LTR
  };
}
//# sourceMappingURL=utils.js.map